import Component from "../abstracts/Component";

export default class SizeTableGroupComponent extends Component {
  get COMPONENTNAME() {
    return 'SizeTableGroupComponent';
  }
  get SELECTORS() {
    return {
      accordions: '[data-js-component="SizeTableComponent"]',
    };
  }

  readDOM() {
    return {
      accordions: Array.from(this.$component.querySelectorAll(this.SELECTORS.accordions)),
    }
  }

  bindEvents() {
    this.dom.accordions.forEach(acc => {
      acc.addEventListener(this.$customEvents.SIZE_GUIDE.toggle, evt => {
        const wasExpanded = evt.target.component.isExpanded();
        this.collapseAll();
        if (!wasExpanded) {
          evt.target.component.expand();
        }
      });
    });
  }

  collapseAll() {
      this.dom.accordions.forEach(acc => {
        acc.component.collapse();
      });
  }

  render() {
    super.render();

    this.dom = this.readDOM();
    this.bindEvents();
  }
}
